import type { RouteRecordRaw } from 'vue-router';

export const mfRoutes: RouteRecordRaw[] = [
  {
    path: '/experience/:city/reviews/',
    name: 'city-listing-reviews',
    component: () => import('@/pages/reviews/ui/ReviewsPage.vue'),
  },
  {
    path: '/experience/:city/:tag/reviews/',
    name: 'city-listing-city-tag-reviews',
    component: () => import('@/pages/reviews/ui/ReviewsPage.vue'),
  },
];

export default mfRoutes;
